import { useEffect, useState } from "react";
import { AiOutlineTeam } from "react-icons/ai";
import { IoShieldHalf } from "react-icons/io5";
import { FaDiscord, FaRegNewspaper } from "react-icons/fa";
import { RiCodeView } from "react-icons/ri";
import { FaCrown } from "react-icons/fa6";

export default function DiscordMembers() {
    const [members, setMembers] = useState([]);

    useEffect(() => {
        fetch("https://api.lexikonn.eu/rpcko/discord_members.php")
            .then((res) => res.json())
            .then((data) => setMembers(data));
    }, []);

    const groupedMembers = {
        "Vedení": members.filter((m) => m.colorText === "text-red-400"),
        "Administrátoři": members.filter((m) => m.colorText === "text-orange-400"),
        "Developeři": members.filter((m) => m.colorText === "text-purple-400"),
        "Správa Discordu": members.filter((m) => m.colorText === "text-blue-400"),
        "Intervieweři": members.filter((m) => m.colorText === "text-teal-400"),
        "Ostatní členové": members.filter((m) => !["text-red-400", "text-orange-400", "text-blue-400", "text-purple-400", "text-teal-400"].includes(m.colorText)),
    };

    const getColorClass = (category) => {
        switch (category) {
            case "Vedení": return "text-red-400";
            case "Administrátoři": return "text-orange-400";
            case "Developeři": return "text-purple-400";
            case "Správa Discordu": return "text-blue-400";
            case "Intervieweři": return "text-teal-400";
            case "Ostatní členové": return "text-white";
            default: return "text-white";
        }
    };

    const getCategoryIcon = (category) => {
        switch (category) {
            case "Vedení": return <FaCrown className="inline-block mr-2" />;
            case "Administrátoři": return <IoShieldHalf className="inline-block mr-2" />;
            case "Developeři": return <RiCodeView className="inline-block mr-2" />;
            case "Správa Discordu": return <FaDiscord className="inline-block mr-2" />;
            case "Intervieweři": return <FaRegNewspaper className="inline-block mr-2" />;
            default: return null;
        }
    };

    return (
        <section className="min-h-screen bg-[#0a0a0a] text-white px-6 py-24 text-center">
            <h2 className="flex items-center justify-center gap-3 text-4xl font-bold text-orange-500 mb-16">
                <AiOutlineTeam className="text-5xl" />
                RPČKO.EU Tým
            </h2>

            {members.length === 0 ? (
                <p className="text-center bg-[#110a0a]">Načítání členů...</p>
            ) : (
                Object.entries(groupedMembers).map(([category, members]) => (
                    members.length > 0 && (
                        <div key={category} className="mb-20">
                            <h3 className={`text-2xl font-bold mb-10 inline-block px-4 py-2 ${getColorClass(category)}`}>
                                {getCategoryIcon(category)}{category}
                            </h3>
                            <div className="flex flex-wrap justify-center gap-10 max-w-7xl mx-auto mt-6">
                                {members.map((member) => (
                                    <div
                                        key={member.id}
                                        className={`relative group flex flex-col items-center text-center bg-gradient-to-br from-[#1a1a1a] to-[#0e0e0e] rounded-2xl px-6 pt-6 pb-4 w-64 border-2 ${member.colorBorder} transition-all duration-300 hover:shadow-xl hover:-translate-y-1`}
                                    >
                                        <div className={`w-24 h-24 rounded-full overflow-hidden border-4 ${member.colorBorder} shadow-md mb-4`}>
                                            <img
                                                src={`https://cdn.discordapp.com/avatars/${member.id}/${member.avatar}.png`}
                                                alt={member.username}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>
                                        <span className="text-xl font-semibold text-white">{member.username}</span>
                                        {member.roleLabel && (
                                            <span className={`mt-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${member.colorText} bg-white/10`}>
                                                {member.roleLabel}
                                            </span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                ))
            )}
        </section>
    );
}
